import { DataFetchingClient } from 'data-fetching-client';
import env from 'enviro';
import { PUBLIC_PRODUCTS_FIELD_POLICIES } from 'pricing-pages-api/products/policies';
export const dataFetchingClient = new DataFetchingClient({
  connectToDevTools: env.isQa(),
  queryFieldPolicies: Object.assign({}, PUBLIC_PRODUCTS_FIELD_POLICIES)
});